export default __webpack_public_path__ + "static/media/VontoCards_LCL-LTL.9b4dc1ba.svg";